export default __webpack_public_path__ + "static/media/google-icon.a4fa9b6f.svg";